import React from "react"
import classnames from "@utils/classnames"
import styles from "./title.module.scss"

const Title = ({ className, sub, children }) => {
  return (
    <div className={classnames(styles.title, className)}>
      <h1>{children}</h1>
      <p>{sub}</p>
    </div>
  )
}

export default Title
